"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

function _default(palette) {
  var primary = (0, _color["default"])(palette.elError),
      hoverColor;
  hoverColor = primary.rotate(2);
  hoverColor = (0, _color["default"])(hoverColor).saturate(0.3);
  hoverColor = (0, _color["default"])(hoverColor).darken(0.2);
  hoverColor = hoverColor.rgb().string();
  return {
    animationBackgroundColor: primary.lighten(0.2).rgb().string(),
    color: palette.tInversion,
    borderColor: palette.elError,
    background: palette.elError,
    focusColor: palette.tInversion,
    focusBorderColor: palette.elError,
    focusBackground: palette.elError,
    hoverColor: palette.tInversion,
    hoverBorderColor: hoverColor,
    hoverBackground: hoverColor,
    activeColor: palette.tInversion,
    activeBorderColor: palette.elError,
    activeBackground: palette.elError,
    disabledColor: palette.tDisabled,
    disabledBorderColor: palette.elDivider,
    disabledBackground: palette.elDivider
  };
}